import { render, staticRenderFns } from "./salesStatisticsSummary.vue?vue&type=template&id=13c37d5c&scoped=true&"
import script from "./salesStatisticsSummary.vue?vue&type=script&lang=js&"
export * from "./salesStatisticsSummary.vue?vue&type=script&lang=js&"
import style0 from "./salesStatisticsSummary.vue?vue&type=style&index=0&id=13c37d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c37d5c",
  null
  
)

export default component.exports